<div class="alert alert-{{ type }}">
  <span class="alert-text w-100 d-inline-block">
    <strong *ngIf="title">{{ title }}<br></strong>
    <span class="d-flex align-items-center">
      <ng-content></ng-content>
    </span>
  </span>
</div>
